import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Guidance from "./routes/Guidance";
import SchoolDocuments from "./routes/SchoolDocuments";
import Dashboard from "./routes/Dashboard";
export default store => ({
  path: "cycles_v2/:cycleId/view",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "cycle-details" */ "./components"),
        import(
          /* webpackChunkName: "cycle-details" */ "VisitorSetup/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const visitorSetupModule = importedModule1;
        const visitorSetupKey = visitorSetupModule.NAME;
        const visitorSetupReducer = visitorSetupModule.default;
        injectReducer(store, {
          key: visitorSetupKey,
          reducer: visitorSetupReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Guidance(store), Dashboard(store), SchoolDocuments(store)],
});
